export const EQUATION_GENERATE_ENDPOINT = "/api/equations/generate";
export const GRAPH_GENERATE_ENDPOINT = "/api/graph";
export const CHAT_AI_ENDPOINT = "/api/conversations";
export const CONVERSATIONS_STREAMING_ENDPOINT = "/api/conversations/stream";
export const EXCEL_FROM_SOURCES_ENDPOINT = "/api/mutate";
export const USER_INFO_ENDPOINT = "/api/user/info";
export const VERIFY_EMAIL_ENDPOINT = "/api/auth/verify-email";
export const RESEND_VERIFY_EMAIL_ENDPOINT = "/api/auth/resend-verify-email-code";
export const CREATE_CHECKOUT_SESSION_ENDPOINT = "/api/stripe/create-checkout-session";
